import io from 'socket.io-client';

export const SocketIO = io("https://socket.missmeowgrooming.com");
// export const SocketIO = io("http://127.0.0.1:3000");